import { render, staticRenderFns } from "./WidgetQualificationTime.vue?vue&type=template&id=fca35d92&scoped=true"
import script from "./WidgetQualificationTime.vue?vue&type=script&lang=js"
export * from "./WidgetQualificationTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca35d92",
  null
  
)

export default component.exports